import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const zh = {
	message: {
		message: '我已阅读并同意',
		agree: '《服务协议》',

		hello: '你好',
		lang: '中文',
		accoPlaceholder: '请输入用户名/手机号',
		passPlaceholder: '请输入密码',
		loginBtnText: '登录',
		logOutText: '退出账号',

		menuText: {
			custManageTitle: '客户管理',
			addManageText: '地址管理',
			orderManageTitle: '订单管理',
			ordercheckTitle: '订单查看',
			signatureFormTitle: '签收单管理',
			deliverymanTitle: '配送员管理',
			deliveryDetailTitle: '配送明细',
			distributionStatisticsTitle: '配送统计',
			temporaryWorkersTitle: '临时工管理',
			clockStatisticsTitle: '打卡统计',
			containerTitle: '新订单（ORDER）',
			containerQueryTitle: '货物信息检索',
			historyOrdersTitle: '历史订单',
			formalWorkersTitle: '正式员工管理',
			reservedCargoManagement: '保留貨物管理',
			amazonOrderTitle: '货物配送明细',
			DiaoDuTitle: '调度管理',
			orderRecycleBinTitle:'垃圾箱',
			xiaoBaoTitle:'GO-FOR配送明细',
			xiaoBaoYuanGongTitle:'GO-FOR派件员',
			ChildAccountTitle:'子账户管理',
			BaoGUoManagerTitle:'包裹管理',
			AreaManagerTitle:'区域管理',
			BLTitle:'BL、搬出票',

		},
		deleteTime:"时间",
		deleteAddress:"地址",

		custManageText: '客户管理',
		addManageText: '地址管理',
		custSearchPlaceholder1: '请输入客户姓名/登录名',
		custSearchPlaceholder: '请输入客户姓名',
		searchBtnText: '搜索',
		addCustBtnText: '新增客户',
		updateCustBtnText: '修改客户',
		customTableTitle1: '序号',
		customTableTitle2: '客户名称',
		customTableTitle3: '密码',
		customTableTitle4: '权限管理',
		customTableTitle5: '操作',
		customTableTitle6: '添加SKU',
		addFileFBA: '添加FBA',
		

		customTableContent: '查看',
		cancleText: '取消',
		confirmText: '确定',
		newCustomerName: '客户姓名',
		newCustomerLoginName: '客户登录名',
		newCustomerPhone: '客户手机号',
		newCustomerSpecial: '特殊模板',
		newCustomerPassword: '客户密码',
		newCustomerCompany: '客户公司',
		newCustomerEmail: '邮箱',
		newCustomerProvince: '省',
		newCustomerCity: '市',
		newCustomerDetailAddress: '详细地址',
		newCustomerPermission: '权限设置',
		newCustomerIsAdmin: '管理员权限',
		newCustomerIsDriverAdmin: '司机管理员',
		newCustomerIsDriverPosition: '司机管理区域',
		createClockInfo: '创建打卡',
		createClockDutyInfo: '勤務日外打刻追加',
		clockTimeInfoTitle: '打卡时间',
		clockPlaceInfoTitle: '打卡地点',
		
		tokyoOffice:'关东地区提货委托',
		osakaOffice:'关西・中部地区提货委托',
		KWS1Office:'JHSS藤井寺・保税・4KWS1',
		SWH7Office:'JHSS市川・保税・2SWH7',
		FWX6Office:'JHSS大田・保税・1FWX6',
		selectTokyo: '东京',
		selectYokohama: '横滨',
		selectOsaka: '大阪',
		selectNagoya: '名古屋',
		selectKobe: '神户',
		selectOther: '其他',

		//正式员工管理
		EmployeeNo:'员工编号',
		BusinessOffice: '营业所',
		isJob:'在职',
		isQuit:'离职',
		NoSiJiTitle:'不是司机',
		placeholder: '请输入',
		permission: [{
			pkid: 'F00',
			label: '客户管理',
		}, {
			pkid: 'F01',
			label: '地址管理',
		}, {
			pkid: 'F02',
			label: '订单管理',
		}, {
			pkid: 'F03',
			label: '订单查看',
		}, {
			pkid: 'F04',
			label: '签收单管理',
		}, {
			pkid: 'F05',
			label: '配送员管理',
		}, {
			pkid: 'F06',
			label: '配送明细',
		}, {
			pkid: 'F07',
			label: '配送统计',
		}, {
			pkid: 'F08',
			label: '临时工管理',
		}, {
			pkid: 'F09',
			label: '新订单（ORDER）',
		}, {
			pkid: 'F10',
			label: '货物信息检索'
		}, {
			pkid: 'F11',
			label: '历史订单'
		}, {
			pkid: 'F12',
			label: '正式员工管理'
		}, {
			pkid: 'F13',
			label: '保留貨物管理'
		}, {
			pkid: 'F14',
			label: '货物配送明细'
		}, {
			pkid: 'F15',
			label: '调度管理'
		}, {
			pkid: 'F16',
			label: '垃圾箱'
		}, {
			pkid: 'F17',
			label: '小包订单'

		}, {
			pkid: 'F20',
			label: '子账户管理'

		}, {
			pkid: 'F24',
			label: 'BL、搬出票'

		}],
		prompt: '此操作将永久删除该客户, 是否继续?',
		promptTitle: '提示',
		addressNameTitle: '客户姓名',
		addressPhoneTitle: '客户手机号',
		addresseeNameTitle: '收件人姓名',
		addresseePhoneTitle: '收件人手机号',
		provienceAddressTitle: '县/省',
		cityAddressTitle: '市',
		detailAddressTitle: '详细地址',
		addresseeAddressTitle: '收件人地址',
		addressAddNameTitle: '添加人姓名',
		addressAddTimeTitle: '添加时间',
		addAddresseeBtnText: '新增地址',
		updateAddresseeBtnText: '修改地址',
		addresseePrompt: '此操作将永久删除该客户地址, 是否继续?',
		canclePrompt: '取消',

		orderSearchPlaceholder: '请输入订单号',
		orderSearchPlaceholder2: '请输入寄件人/收件人姓名',
		orderStatusList: [{
			value: 0,
			label: '运输中'
		}, {
			value: 1,
			label: '配送中'
		}, {
			value: 2,
			label: '已签收'
		}, {
			value: 3,
			label: '已作废'
		}],
		WAREHOUSEList: [{
			value: '市川',
			label: '市川'
		}, {
			value: '大田',
			label: '大田'
		}, {
			value: '藤井寺',
			label: '藤井寺'
		}],
		orderTimeStartHolder: '开始时间',
		orderTimeEndHolder: '结束时间',
		orderSearchPlaceholder3: '请选择收件省份',
		orderSearchPlaceholder4: '请输入备注',
		addOrderBtnText: '新增订单',
		updateOrderBtnText: '修改订单',
		orderTableTitle1: '订单号',
		orderTableTitle2: '条形码',
		orderTableTitle3: '运输情况',
		orderTableTitle4: '寄件公司名',
		orderTableTitle5: '寄件人姓名',
		orderTableTitle6: '联系电话',
		orderTableTitle7: '物品数量',
		orderTableTitle8: '物品称重',
		orderTableTitle9: '物品体积',
		orderTableTitle10: '订单状态',
		orderTableTitle11: '创建时间',
		orderState0: '运输中',
		orderState1: '配送中',
		orderState2: '已签收',
		orderState3: '已作废',
		orderTableCheckTitle: '查看',
		senderPhoneTitle: '寄件人电话',
		senderEmailTitle: '寄件人email',
		senderProvienceTitle: '寄件县/省',
		senderCityTitle: '寄件市',
		senderAddressTitle: '寄件地址',
		addresseeInfoTitle: '收件人信息',
		addresseeProvienceTitle: '收件县/省',
		addresseeCityTitle: '收件市',
		addresseeTitle: '收件地址',
		addresseeCompanyTitle: '收件公司名',
		addresseeNameTitle: '收件人姓名',
		addresseePhoneTitle: '收件人电话',
		addresseeEamilTitle: '收件人email',

		orderRemarkTitle: '货物编号',

		orderPrompt: '此操作将永久删除该订单, 是否继续?',
		orderPromptYs: '此操作将永久删除预设状态, 是否继续?',
		orderCanclePrompt: '此操作将永久作废该订单, 是否继续?',
		downLoadExcel: '下载模板',
		importExcelTitle: '导入',
		selectExcel: '选择文件',
		importExcelError: '文件上传失败',
		importExcelCheck: '查看导入文件',
		confirmImportExcel: '确定导入',
		setOrdersContainer: '设置集装箱',
		delOrderText: '删除',
		savesOrderText: '保存',


		backText: '返回',
		addNewLogisticsText: '新增物流信息',
		updateLogisticsText: '修改物流信息',
		goodsStatusTitle: '货物状况',
		deliveryStatusTitle: '配送状况',
		positionTitle: '到达位置',
		logisticsImgTitle: '物流图片',
		dateTitle: '物流日期',
		uploadLogisticsImg: '上传图片',
		logisticsPrompt: '此操作将永久删除该物流信息, 是否继续?',
		startLogistics: '开始配送',
		endlogistics: '完成配送',
		orderHasCompleteText: '确认订单已完成',

		signatureSearchPlaceholder: '请输入签收单名称',
		signatureSearchPlaceholder2: '请输入签收单号',
		addSignatureBtnText: '新建签收单',
		signatureFormName: '签收单名称',
		signatureNumTitle: '签收单号',
		signatureOrderTitle: '订单',
		signatureOrderImgTitle: '图片',
		signatureStateTitle: '状态',
		signatureAddUserTitle: '创建人',
		signatureAddTimeTitle: '创建时间',
		signaturePrompt: '此操作将永久删除该签收单信息, 是否继续?',
		signatureNotOrder: '添加',
		signatureHasOrder: '查看',
		signatureStatusTitle1: '进行中',
		signatureStatusTitle2: '已完成',
		signatureInsertOrderSearchPlaceholder: '请输入关键字',
		signatureInsertOrderText: '加入订单',
		signatureInsertImgText: '加入照片',
		signatureInsertTipsText: '请选择订单',
		signatureInsertPrompt: '是否加入订单',
		uploadImgErrorFormatText: '上传图片只能是 JPG 格式!',
		uploadImgErrorTipsText: '图片上传失败，请重试',
		uploadImgNoImgTitle: '请选择图片上传',
		signatureInsertImgPrompt: '是否加入图片',
		endSignatureTitle: '是否完结该签收单？',
		signOrderTitleText: '签收单订单',

		deliveryAreaTitle: '请选择配送范围',
		addDeliveryManTitle: '新增配送员',
		updateDeliveryManTitle: '修改配送员',
		deliveryAccountTitle: '登录账号',
		deliveryNameTitle: '配送员姓名',
		deliveryPasswordTitle: '登录密码',
		deliveryAreaTitle: '配送范围',
		deliveryPhoneTitle: '手机号',
		deliveryEmailTitle: '邮件',
		delDeliveryPrompt: '此操作将永久删除该配送员, 是否继续?',

		deliveryManTitle: '配送员',
		deliveryTimeTitle: '配送时间',
		deliveryNumTitle: '配送数量',
		exportText: '导出',

		tempeoraryNameTitle: '临时员工姓名',
		attendanceTimeTitle: '出勤时间',
		addTempeoraryManTitle: '新增临时员工',
		updateTempeoraryManTitle: '修改临时员工',
		todayClockNum: '今日打卡人数',
		tempeoraryNameTitle: '姓名',
		tempeoraryPhoneTitle: '手机号',
		tempeoraryEmailTitle: '邮箱',
		tempeoraryAccountTitle: '账号',
		tempeoraryPasswordTitle: '密码',
		airportWageTitle: '机场路费',
		warehouseWageTitle: '仓库路费',
		dailyWageTitle: '月度补贴上限',
		hourlyWageTitle: '时薪',
		monthlyPassTitle: '交通费月票',
		attendanceNumTitle: '出勤总次数',
		attendanceHoursTitle: '出勤总工时',
		driverArea: '司机所属地区',
		clockInDetailTitle: '打卡明细',
		delTempeoraryPeompt: '此操作将永久删除该临时员工, 是否继续?',
		delClockInfo: '此操作将永久删除该打卡信息, 是否继续?',
		delClockmessage:'该打卡明细不符合删除规则',
		clockInAddTitle: '打卡地点',
		punchInTimeTitle: '上班打卡时间',
		punchOutTimeTitle: '下班打卡时间',
		manHourTitle: '工时',
		strippingStartTime: '拆柜开始时间',
		strippingTime: '拆柜时间',
		strippingEndTime: '拆柜结束时间',
		strippingSize: '拆柜尺寸',
		strippingNum: '拆柜数量',
		littleSize: '小尺寸',
		bigSize: '大尺寸',

		containerTitle: '订单信息',
		week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
		noEnterContainersNum: '未录入集装箱数量',
		newContainerTitle: '新建订单',
		modifyContainerTitle: '修改订单',
		// containerOrderCity: '城市',
		containerOrderCity: '营业所',
		containerJOBNO: 'JHSS工作号',
		containerCreater: '担当者',
		containerOrderModel: '集装箱型号',
		containerGoodsModel: '货物类型',
		litijin: '立替金',
		containerText: '集装箱',
		containerOrderNumber: '集装箱编码',
		containerTrailerArrangement: '集装箱拖车安排',
		placeOfDelivery: '提货地点',
		containerOrderArrivalDate: '操作时间',
		containerStripping: '集装箱操作时间',
		deliveryDate: '可提货时间段',
		trailerArrangement: '集装箱拖车安排',
		containerTransportWays1: 'JHSS提柜-  JHSS拆柜',
		containerTransportWays11: 'JHSS提柜-  JHSS装柜',
		containerTransportWays2: '集装箱送到JHSS仓库-  JHSS拆柜',
		containerTransportWays21: '集装箱送到JHSS仓库-  JHSS装柜',
		containerTransportWays3: 'JHSS提柜直送-',



    goodsNo:'货物单号',
    amazonCode:'Amazon  code',
    caseNo:'箱号',
    FBATagNO:'FBA标签号',
    SKUTagNo:'SKU标签号',
    SKUNumber:'pcs',
    tradeName:'商品名称',
    productRemarks:'商品备注',
    commodityPhotos:'商品照片',
    labelingRemarks:'贴标备注栏',
    

		hasSpecifyTime: '有',
		noSpecifyTime: '无',
		specifyTime: '指定时间',
		containerOrderCustomerID: '客户ID',
		containerOrderCustomer: '客户全称',
		customerDedicatedNum: '客人专用编号',
		containerOrderNum: '数量',
		containerOrderVolume: '体积',
		containerOrderWeight: '重量',
		containerOrderRemark: '备注',
		containerOrderAttacherFile: '附加文件',
		addFileText: '添加文件',
		noAttachment: '没有附加文件',
		goodsStatus: '货物状况',
		setGoodsStatus: '设置',
		hasArrive: '已到达',
		notArrive: '未到达',
		containerCondition: '集装箱情况',
		conditionAbnormal: '是否异常',
		normalCondition: '正常',
		abnormalCondition: '异常',
		adnormalRemark: '异常添加说明',
		abnormalUpload: '异常情况上传',
		exportDatePlaceholder: '请选择',
		kantoReceipt: '关东签收单',
		kansaiReceipt: '关西签收单',
		containerReceipt: '签收单',
		containerReturnReceipt: '回传签收单',
		FBASKUtally: 'FBA/SKU标签',
		billTitle: '账单',
		uploadReceipt: '上传文件',
		sendEmailPeompt: '是否发送邮件?',
		containerOrdersDetails: '订单明细',
		numberUnitPlaceholder: '请填写数量单位！',
		downloadNumber: '下载情况',
		download: '下载文件',
		downloadCode: '下载二维码',

		affirmText: '确认',
		confirmPeople: '确认人',
		affirmTime: '确认时间',
		remarkFillSuccess: '备注填写完成',
		SKUInfoFillSuccess: 'SKU填写完成',

		tallyName: '标签名称',
		cancelAffirmText: '取消确认',
		hasAffirm: '已确认',
		notAffirm: '未确认',
		uploadTimetext: '上传时间',

		containerQueryTitle1: '日期',
		createContainerOrder: '更新集装箱信息',
		arrivePort: '抵达港口',
		inspection: '查验',

		orderHistoryState: [{
			value: '0',
			label: '已归档'
		}, {
			value: '1',
			label: '已删除'
		}],

		addformalWorkersTitle: '新增正式员工',
		updateformalWorkersTitle: '修改正式员工',
		// 保留货物管理
		placeholderKeyword: '请输入关键字',
		placeholderColumn: '请选择搜索列',
		createCargoTable: '創建保留在庫表',
		deleteCargoTable: '删除该行保留在庫表',

		mainOrDeputyPlaceholder: '请输入主单号/副单号',
		queryBtnText: '查询',
		uploadBtnText: '上传',
		signInTimeStartPlaceholder: '创建开始时间',
		signInTimeEndPlaceholder: '创建结束时间',
		amazonOrderStatus: '请选择状态',
		signInOrderStatus1: '异常',
		signInOrderStatus2: '正常',
		containerOrderLogisticsStatus: '请选择物流状态',
		orderTemplateDialogTitle: '下载模板',
		orderTemplateUploadTitle: '上传',
		templateTypeTitle: '模板类型',
		specialTemplate: '特别模板',
		normalTemplate: '通用模板',
		FCSpecialTemplate: 'FC-特别模板',
		batchUpdateLogisticsInfo: '批量设置物流信息',
		batchSetStatus: '批量设置状态',
		batchDelete: '批量删除',
		batchDeleteYs: '批量删除预设',
		createSignInImg: '创建签收单',
		signInImgName: '名称',
		signInOrderCustomer: '客户',
		uploadFileTitle: '文件',
		mainOrderNum: '唛头',
		deputyOrderNum: '货物编号',

		numInOrder: '个数',
		addressInOrder: '地址',
		estimatedTimeArrival: '提货时间',
		uploadOrderFileError: '文件格式错误，请重新选择！',
		uploadOrderNoFileError: '文件内没有内容！',
		checkLogisticsText: '查看物流',
		goodsDescription: '货物情况',
		deliverySituation: '送货情况',
		deliverySituationY: '预置状态',
		logisticsDate: '日期时间',
		setOrderStatus: '设置状态',
		orderStatusRemark: '备注说明',
		deliverySituation1: '已提货',
		deliverySituation2: '配送中',
		deliverySituation3: '已派送',
		deliverySituation4: '提回仓库',
		deliverySituation5: '拒收',
		deliverySituation6: '再次派送',
		deliverySituation7: '未更新',

		queryPlaceholder1: '请输入副单号查询', // 主单号/
		queryPlaceholder2: '多个订单用“,”隔开',
		orderDetails: '订单详情',
		deliveryAddress: '派送地址',
		deliveryOrderTitle: '派送单',
		querySuborderTitle: '单号',
		delOrderLogisticsPrompt: '此操作将永久删除该物流信息，是否继续？',
		setPPrompt: '确定已打印该订单全部签收单吗?',

		IsSiJi: '是否司机',
		IsExternalSiJi: '外部司机',
		SiJiTitle: '司机',
		DriverAreaAll: '全部',
		DriverAreaTokyo: '東京',
		DriverAreaOsaka: '大阪',
		DiaoDuTitle: '调度管理',
		orderRecycleBinTitle:'垃圾箱',
		QuHuoTitle: '取货',
		SongHuoTitle: '送货',
		AddCarTitle: '新增车辆',
		CarNoTitle: '车牌号',
		SongHuoXingChengTitle: '送货行程',
		PleaseAddCarNo: '请填写车牌号',
		setStatus: '设置',
		LeiXingTitle: '类型',
		SetOrderAndXingChengTitle: '绑定订单',
		XingChengTimeTitle: '行程时间',
		XingChengTitle1: '行程1',
		XingChengTitle2: '行程2',
		XingChengTitle3: '行程3',
		XingChengTitle4: '行程4',
		XingChengTitle5: '行程5',
		XingChengTitle6: '行程6',
		XingChengTitle7: '行程7',
		XingChengTitle8: '行程8',
		XingChengTitle9: '行程9',
		XingChengTitle10: '行程10',
		XingChengTitle11: '行程11',
		XingChengTitle12: '行程12',
		XingChengTitle13: '行程13',
		XingChengTitle14: '行程14',
		XingChengTitle15: '行程15',
		CarAndSiJiTitle: '车牌号和司机',
		
		
		HDS: 'HDS货物',
		ShouJianYouBian: '收件人邮编',
		ShouJianSheng: '收件地址1',
		ShouJianShi: '收件市',
		ShouJianDiZhi: '收件地址2',
		ShouJianGongSi: '收件公司名',
		ShouJianName: '收件人姓名',
		ShouJianPhone: '收件人电话',
		Mark: 'MARK',
		HuoWuCode: '货物单号',
		HuoWuPc: '货物数量(pc)',
		HuoWuKg: '货物重量(kg)',
		HUoWuM: '货物三边和(cm)',
		KeHuCode: '客户代码',
		JiJianPeo: '寄件人',
		JiJianPhone: '寄件人电话',
		JiJianYouBian: '寄件人邮编',
		JiJianDiZhi: '寄件人地址',
		UpdateExcelTitle:'更新数据',
		SystemOrderNum:'GOFOR单号',
		
		ISCANDOOR:'可以放在门口吗',
		SENDTYPE:'派送方式',
		CUSTOMERNO:'客户管理单号',
		
		BaoGuoName:'包裹名称',
		BaoGuoQrcode:'包裹二维码编号',
		BaoGuoCode:'区域编号',
		CityName:'所属城市',
		AreaSuoShuName:'所属区域',
		AreaName:'区域名称',
		AreaOrderCode:'区域订单码',
		AddTitle:'新增',
		EditTitle:'编辑',
		SortidTitle:'序号',
		BaoGuoAddTitle1:'请输入包裹名称',
		BaoGuoAddTitle2:'请输入包裹序号',
		BaoGuoAddTitle3:'请输入包裹所属区域',
		
		GuiDangDingdan:'历史订单',
		ThreeMonthOrder:'3个月前历史订单查询',
		GuiDangDingdanBack:'返回新订单（ORDER）',
		PrintMulOrdersText:'批量打印',
		XuKeText:"许可状况",
		HaveXuKeText:"已许可",
		NoXuKeText:"未许可",
		ImpSumOrder:"批量导入订单",
		chaiguiTime:"拆柜时间",
		weicaozuoTitle:"未抵达",//未操作
		yididaTitle:"已抵达",//已抵达
		yianpaiTitle:"已拆柜",//已安排
		yiwanchengTitle:"空柜已出库",//已完成
		xukejihuowu:"已许可货物",
		WAREHOUSE:"保税仓",
		HBLCOMPANY:"HBL 公司名",
		SUMSL:"总数量",
		SUMZL:"总重量",
		SUMTJ:"总体积",
		
		SHIPNAME:"本船名",
		VOY:"VOY.",
		PlaceofLoading:"Place of Loading",
		PlaceofDelivery:"Place of Delivery",
		ETA:"ETA",
		MBLNO:"MBL NO",
		Shipper:"Shipper",
		Consignee:"Consignee",
		pinming:"品名",
		HBLNO:"HBL NO",
		Num:"個数",
		UNIT:"数量単位",
		Zl:"重量",
		NaPin:"納品先",
		M3:"M3",
		dandang:"JHSS担当者",
		banchudate:"搬出予定日",
		AllPrint:"批量印刷搬出票",
		OnePrint:"分单下载搬出票",
		AllPrintBL:"批量印刷HBL、HAN",			 
		batchSetInfo: '批量设置'
		
	},
	...zhLocale
}

export default zh
